import { useState } from 'react';
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';

type PinInputProps = {
  onPinChange: (pin: string) => void;
  withCodePasteButton?: boolean;
};

const PinInput = ({ onPinChange, withCodePasteButton }: PinInputProps) => {
  const [pin, setPin] = useState('');

  const handleChange = (value: string) => {
    setPin(value);
    onPinChange(value);
  };

  const pasteCode = () => {
    navigator.clipboard.readText().then((text) => {
      const filteredDigits = text.replace(/\D/g, '').slice(0, 4);
      setPin(filteredDigits);
      onPinChange(filteredDigits);
    });
  };

  return (
    <div className="flex flex-col !overflow-clip" onKeyDown={(e) => e.key === 'Tab' && e.preventDefault()}>
      <div className="self-center w-full">
        <InputOTP
          maxLength={4}
          pattern={REGEXP_ONLY_DIGITS}
          value={pin}
          onChange={handleChange}
          className="w-full"
          data-testid={DataTestIdEnum.PIN_INPUT}
        >
          <InputOTPGroup className="flex gap-4 w-full">
            <InputOTPSlot index={0} data-testid={DataTestIdEnum.PIN_INPUT_SLOT_0} />
            <InputOTPSlot index={1} data-testid={DataTestIdEnum.PIN_INPUT_SLOT_1} />
            <InputOTPSlot index={2} data-testid={DataTestIdEnum.PIN_INPUT_SLOT_2} />
            <InputOTPSlot index={3} data-testid={DataTestIdEnum.PIN_INPUT_SLOT_3} />
          </InputOTPGroup>
        </InputOTP>
      </div>
      {withCodePasteButton && (
        <span
          className="text-green-500 text-base font-semibold cursor-pointer mt-5 animate-slide-down duration-100"
          onClick={pasteCode}
        >
          Colar código
        </span>
      )}
    </div>
  );
};

export default PinInput;
